/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Trust_One_Project_TokenInputs */

const en_directory_agents_trust_one_project_token = /** @type {(inputs: Directory_Agents_Trust_One_Project_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The token controls exactly one project and nothing else. Revoke it any time from My tools.`)
};

const zh_directory_agents_trust_one_project_token = /** @type {(inputs: Directory_Agents_Trust_One_Project_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`令牌只控制这一个项目，别无其他；随时可在「我的产品」中吊销。`)
};

/**
* | output |
* | --- |
* | "The token controls exactly one project and nothing else. Revoke it any time from My tools." |
*
* @param {Directory_Agents_Trust_One_Project_TokenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_trust_one_project_token = /** @type {((inputs?: Directory_Agents_Trust_One_Project_TokenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Trust_One_Project_TokenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_trust_one_project_token(inputs)
	return zh_directory_agents_trust_one_project_token(inputs)
});
export { directory_agents_trust_one_project_token as "directory.agents.trust_one_project_token" }